import { lazy } from '../../../shared/deployment';

// eslint-disable-next-line import/prefer-default-export
export const ChatCompanion = lazy(() => import('./ChatCompanion'));
